import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';
import { withStyles } from '@material-ui/core';
import { Grid, Button, IconButton, CircularProgress, TextField, Typography } from '@material-ui/core';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { clearErrors } from "../../actions/errorActions";  // Vérifie bien le chemin

import styles from './styles';
import schema from './schema';
import { connect } from "react-redux";
import { loginUser, logoutUser } from "../../actions/authActions";
import api from '../../api'; // Gestion des erreurs globales Axios

class SignIn extends Component {
  state = {
    values: {
      identifier: '',
      password: '',
    },
    touched: {
      identifier: false,
      password: false,
    },
    errors: {
      identifier: null,
      password: null,
    },
    isValid: false,
    isLoading: false,
    errorMessage: '',
    successMessage: '',
  };
  componentDidUpdate(prevProps) {
    // Redirection si l'utilisateur vient de s'authentifier
    if (!prevProps.auth.isAuthenticated && this.props.auth.isAuthenticated) {
      this.setState({ successMessage: "✅ Login successful! Redirecting..." });
      setTimeout(() => {
        this.props.history.push("/dashboard");
      }, 1000);
    }
  
    // Mise à jour du message d'erreur si une erreur est reçue
    if (prevProps.errors !== this.props.errors && this.props.errors.message) {
      this.setState({ errorMessage: this.props.errors.message });
    }
  }
  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      console.log("🔄 Déjà authentifié, redirection vers le dashboard...");
      this.props.history.push("/dashboard");
    }
    
    // Nettoie les erreurs précédentes dès l'affichage de la page
    this.props.clearErrors();
  }
  
componentWillReceiveProps(nextProps) {
  if (nextProps.auth.isAuthenticated) {
    this.setState({ successMessage: "✅ Login successful! Redirecting..." });
    setTimeout(() => {
      this.props.history.push("/dashboard");
    }, 1000);
  }

  if (nextProps.errors && nextProps.errors.message) {
    this.setState({ errorMessage: nextProps.errors.message });
  }
}

  handleBack = () => {
    this.props.history.goBack();
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;
    let errors = validate(values, schema) || {};

    this.setState({
      errors,
      isValid: Object.keys(errors).length === 0,
    });
  }, 300);

  handleFieldChange = (field, value) => {
    if (this.props.clearErrors) {
      this.props.clearErrors(); // Efface les erreurs lorsque l'utilisateur modifie un champ
    }
  
    this.setState(
      prevState => ({
        values: {
          ...prevState.values,
          [field]: value,
        },
        touched: {
          ...prevState.touched,
          [field]: true,
        },
        errorMessage: '',
        successMessage: '',
      }),
      this.validateForm
    );
  };
  

  handleSignIn = async () => {
    try {    if (!this.state.values) {
      console.warn("⚠️ Warning: `values` is undefined, resetting state.");
      this.setState({
        values: { identifier: '', password: '' }, // Valeurs par défaut
      });
    }

    this.setState({ isLoading: true, errorMessage: '', successMessage: '' });

    const userData = {
      identifier: this.state.values.identifier || '',
      password: this.state.values.password || '',
    };

    console.log("🔑 Sending login request with:", userData);

    await this.props.loginUser(userData);
    this.setState({ isLoading: false });

    } catch (error) {
      console.error("❌ Login error:", error.response ? error.response.data : error);
      let errorMessage = "❌ An unknown error occurred.";
      if (error.response) {
        console.log("🔍 Détails de l'erreur :", error.response);
        
        if (error.response.status === 401 ) {
          errorMessage = `❌ ${error.response.data?.message || "Incorrect username or password."}`;
        } else if (error.response.status === 500) {
          errorMessage = "❌ Server error, please try again latecontr.";
        } else if (error.response.status === 403) {
          errorMessage = `❌ ${error.response.data?.message || "Contact an admin to validate your account"}`;
        } else {
          errorMessage = `❌ ${error.response.data?.message || "Unexpected error occurred."}`;
        }
      }
      

      this.setState({
        isLoading: false,
        errorMessage,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { values, touched, errors, isValid, isLoading, errorMessage, successMessage } = this.state;
    const { loading } = this.props.auth;

    return (
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.quoteWrapper} item lg={5}>
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography className={classes.quoteText} variant="h1" gutterBottom>
                  Industry Proven Client Video Solutions for All Platforms
                </Typography>
                <div className={classes.person}>
                  <Typography className={classes.name} variant="body1">
                    © 2021 VisualOn Inc
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton className={classes.backButton} onClick={this.handleBack}>
                  <ArrowBackIcon />
                </IconButton>
              </div>
              <div className={classes.contentBody}>
                <form className={classes.form}>
                  <Typography className={classes.title} variant="h2">
                    Sign in
                  </Typography>
                  <Typography className={classes.sugestion} variant="body1">
                    Login with email or username
                  </Typography>
                  {this.state.errorMessage && (
                    <Typography color="error" align="center">
                      {this.state.errorMessage}
                    </Typography>
                  )}

                  {successMessage && (
                    <Typography color="primary" align="center" style={{ animation: "fadein 0.5s" }}>
                      {successMessage}
                    </Typography>
                  )}
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      label="Email or Username"
                      name="identifier"
                      onChange={event => this.handleFieldChange('identifier', event.target.value)}
                      onKeyDown={event => {
                        if (event.key === 'Enter' && isValid) {
                          this.handleSignIn();
                        }
                      }}
                      type="text"
                      value={values.identifier}
                      variant="outlined"
                    />
                    {touched.identifier && errors.identifier && (
                      <Typography className={classes.fieldError} variant="body2">
                        {errors.identifier[0]}
                      </Typography>
                    )}
                    <TextField
                      className={classes.textField}
                      label="Password"
                      name="password"
                      onChange={event => this.handleFieldChange('password', event.target.value)}
                      onKeyDown={event => {
                        if (event.key === 'Enter' && isValid) {
                          this.handleSignIn();
                        }
                      }}
                      type="password"
                      value={values.password}
                      variant="outlined"
                    />
                    {touched.password && errors.password && (
                      <Typography className={classes.fieldError} variant="body2">
                        {errors.password[0]}
                      </Typography>
                    )}
                  </div>

                  {loading || isLoading ? (
                    <CircularProgress className={classes.progress} />
                  ) : (
                    <Button
                      className={classes.signInButton}
                      color="primary"
                      disabled={!isValid}
                      onClick={this.handleSignIn}
                      size="large"
                      variant="contained"
                    >
                      Sign in now
                    </Button>
                  )}

                  <Link className={classes.signUpUrl} to="/password/forgot">
                    Forgot password?
                  </Link>
                  <Typography className={classes.signUp} variant="body1">
                    Don't have an account?{" "}
                    <Link className={classes.signUpUrl} to="/sign-up">
                      Sign Up
                    </Link>
                  </Typography>

                </form>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

SignIn.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, { loginUser, logoutUser, clearErrors })
)(SignIn);
